import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { PolarisProjectTemplate } from '@atlassian/jira-polaris-domain-project/src/types.tsx';

type ProjectId = string;

export const getOnboardingInformation = (projectId: ProjectId): Promise<PolarisProjectTemplate> =>
	fetchJson(
		`/rest/polaris/project-template/onboarding-information/${projectId}?operation=getJpdOnboardingInformation`,
	);
